module.exports = __webpack_public_path__ + "static/media/gold-white-zigzag.c02abc29.jpg";